import axios from '@axios'
import moment from "moment";

export default {
    namespaced: true,
    state: {
        codigo: null,
        tipos: [{ co_tipo: null, nombre: "Ninguno" }],
        tiposSol: [{ co_tipo: null, nombre: "Ninguno" }],
        canales: [{ Id_tipo: null, nombre: "Ninguno" }],
        canalesSol: [],
        subcanales: [{ id_subtipo: null, nombre: "Ninguno" }],
        detalle: [{
            id: null,
            fecha: moment().format("YYYY-MM-DD"),
            monto: null,
            comentario: null,
        }],
        canalesAll: [{ Id_tipo: null, nombre: "Todos" }],
        presupuestos: [{ co_tipo: null, nombre: "Todos" }],
        solicitudPr: [],
        solicitudPrCabecera: {
            co_solicitud: 0,
            division: null,
            detalle: [],
            factura: [],
            FechaInicio: null,
            FechaFin: null,
            Monto: null,
        },
        solicitudPrDetalle: [],
        gastosPr: [{ co_concepto: null, descripcion: "Ninguno" }],
        clientePr: [],
        SaldoPr: [],
        permisoPr: [],
        subcanales2: [],
        conceptos: [],
        tiposProducto: [],
        divisiones: [],
        canalesMuestra: [],
        vendedores: [],
        clientesMuestra: [],
        unidades: [],
        unidadesConversion: [],
        pedidosMuestras: [],
        beneficiarios: [],
        SERIESVENTAS: [],
        AprobarPromociones:[],
    },
    getters: {
        getPermisoPr(state) {
            return state.permisoPr
        },
        getClientesCanalPr(state) {
            return state.clientePr
        },
        getGastosPr(state) {
            return state.gastosPr
        },
        getSolicitudPr(state) {
            return state.solicitudPr
        },
        getSolicitudPrCabecera(state) {
            return state.solicitudPrCabecera
        },
        getSolicitudPrDetalle(state) {
            return state.solicitudPrDetalle
        },
        getTiposPr(state) {
            return state.tipos
        },
        getTiposSolPr(state) {
            return state.tiposSol
        },
        getCanalesPr(state) {
            return state.canales
        },
        getCanalesSolPr(state) {
            return state.canalesSol
        },
        getCanalesAll(state) {
            return state.canalesAll
        },
        getPresupuestos(state) {
            return state.presupuestos
        },
        getCodigo(state) {
            return state.codigo
        },
        getSubCanalesPr(state) {
            return state.subcanales
        },
        getPresupuestoDetalle(state) {
            return state.detalle
        },
        getSaldoPr(state) {
            return state.SaldoPr
        },
        getSubcanales2(state) {
            return state.subcanales2
        },
        getConceptos(state) {
            return state.conceptos
        },
        getTiposProducto(state) {
            return state.tiposProducto
        },
        getDivisiones(state) {
            return state.divisiones
        },
        getCanalesMuestra(state) {
            return state.canalesMuestra;
        },
        getVendedores(state) {
            return state.vendedores;
        },
        getClientesMuestra(state) {
            return state.clientesMuestra;
        },
        getUnidades(state) {
            return state.unidades;
        },
        getUnidadesConversion(state) {
            return state.unidadesConversion;
        },
        getPedidosMuestras(state) {
            return state.pedidosMuestras;
        },
        getBeneficiarios(state) {
            return state.beneficiarios;
        },

        getSeriesVentas(state){
            return state.SERIESVENTAS;
        },

        getAprobarPromociones(state){
            return state.AprobarPromociones;
        }
    },
    mutations: {
        setClientePr(state, clientePr) {
            state.clientePr = clientePr;

        },
        setGastosPr(state, gastosPr) {
            state.gastosPr = state.gastosPr.concat(gastosPr);

        },
        setSolicitudPr(state, solicitudPR) {
            state.solicitudPR = solicitudPR
        },
        setSolicitudPrCabecera(state, solicitudPrCabecera) {
            state.solicitudPrCabecera = solicitudPrCabecera
        },
        setSolicitudPrDetalle(state, ) {
            state.solicitudPrDetalle = solicitudPrDetalle
        },
        setSaldoPr(state, SaldoPr) {
            state.SaldoPr = SaldoPr
        },
        setPermiso(state, permisoPr) {
            state.permisoPr = permisoPr
        },
        setTiposPr(state, tipos) {
            state.tipos = state.tipos.concat(tipos);
        },
        setTiposSolPr(state, tipos) {
            state.tiposSol = tipos;
        },
        setCanalesPr(state, canales) {
            state.canales = state.canales.concat(canales);
        },
        setCanalesSolPr(state, canales) {
            state.canalesSol = canales;
        },
        setCanalesAll(state, canalesAll) {
            state.canalesAll = state.canalesAll.concat(canalesAll);
        },
        setPresupuestos(state, presupuestos) {
            state.presupuestos = state.presupuestos.concat(presupuestos);
        },
        resetClientePr(state, clientePr) {
            state.clientePr = clientePr
        },
        resetCanalesPr(state, canales) {
            state.canales = canales
        },
        resetGastosPr(state, gastosPr) {
            state.gastosPr = gastosPr
        },
        resetPresupuestos(state, presupuestos) {
            state.presupuestos = presupuestos
        },
        setCodigo(state, codigo) {
            state.codigo = codigo
        },
        setSubCanalesPr(state, subcanales) {
            state.subcanales = state.subcanales.concat(subcanales);
        },
        resetSubCanalesPr(state, subcanales) {
            state.subcanales = subcanales
        },
        setPresupuestoDetalle(state, detalle) {
            state.detalle = detalle
        },
        addPrDet(state, detalle) {
            state.detalle.push(detalle)
        },
        clearAll(state) {
            state.codigo = null
            state.tipos = [{ co_tipo: null, nombre: "Ninguno" }]
            state.canales = [{ Id_tipo: null, nombre: "Ninguno" }]
            state.subcanales = [{ id_subtipo: null, nombre: "Ninguno" }]
            state.detalle = [{
                id: null,
                fecha: moment().format("YYYY-MM-DD"),
                monto: null,
                comentario: null,
            }]
        },
        delPrDet(state, index) {
            state.detalle.splice(index, 1)
            if (state.detalle.length === 0) {
                state.detalle.push({
                    id: null,
                    fecha: moment().format("YYYY-MM-DD"),
                    monto: null,
                    comentario: null,
                })
            }
        },
        setSubcanales2(state, subcanales2) {
            state.subcanales2 = subcanales2
        },
        setConceptos(state, conceptos) {
            state.conceptos = conceptos
        },
        setTiposProducto(state, tiposProducto) {
            state.tiposProducto = tiposProducto
        },
        setDivisiones(state, divisiones) {
            state.divisiones = divisiones
        },
        setCanalesMuestra(state, canalesMuestra) {
            state.canalesMuestra = canalesMuestra
        },
        setVendedores(state, vendedores) {
            state.vendedores = vendedores
        },
        setClientesMuestra(state, clientesMuestra) {
            state.clientesMuestra = clientesMuestra
        },
        setUnidades(state, unidades) {
            state.unidades = unidades
        },
        setUnidadesConversion(state, unidadesConversion) {
            state.unidadesConversion = unidadesConversion
        },
        setPedidosMuestras(state, pedidosMuestras) {
            state.pedidosMuestras = pedidosMuestras
        },
        setBeneficiarios(state, beneficiarios) {
            state.beneficiarios = beneficiarios
        },
        SET_SERIESVENTAS(state,SERIESVENTAS){
            state.SERIESVENTAS = SERIESVENTAS
        },
        setAprobarPromociones(state,AprobarPromociones){
            state.AprobarPromociones = AprobarPromociones
        }
    },
    actions: {
        clearCanales({ commit }) {
            commit('resetCanalesPr', [{ Id_tipo: null, nombre: "Ninguno" }])
        },
        clearGastos({ commit }) {
            commit('resetGastosPr', [{ co_concepto: null, descripcion: "Ninguno" }])
        },
        clearClientes({ commit }) {
            commit('resetClientePr', [{ Codigo: null, NombreComercial: "Ninguno" }])
        },
        clearPresupuestos({ commit }) {
            commit('resetPresupuestos', [{ co_tipo: null, nombre: "Todos" }])
        },
        clearSubCanales({ commit }) {
            commit('resetSubCanalesPr', [{ id_subtipo: null, nombre: "Ninguno" }])
        },
        resetModalSolicitud({ commit }) {
            commit('setSolicitudPrCabecera', {
                co_solicitud: null,
                tipo: {
                    co_tipo: null,
                    nombre: null,
                    marketing: null,
                },
                detalle: [],
                factura: []
            }, )
        },
        //tonny get 1 parametro
        fetchSaldoPr({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post("/api/auth/ventas/saldos", data)
                    .then(response => {
                        commit("setSaldoPr", response.data);
                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                        console.error(error);
                    });
            })
        },
        fetchPrecioSubcanal({}, data) {
            return new Promise((resolve, reject) => {
                axios.post("/api/auth/ventas/precioSubcanal", data)
                    .then(response => {
                        resolve(response.data[0].precio_subcanal)
                    })
                    .catch(error => {
                        reject(error);
                        console.error(error);
                    });
            })
        },
        fetchSubcanales2({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get("/api/auth/ventas/subcanales2", { params: data })
                    .then(response => {
                        commit("setSubcanales2", response.data.canales);
                        resolve(response.data.validador);
                    })
                    .catch(error => {
                        reject(error);
                        console.error(error);
                    });
            })
        },
        fetchClientesSolicitud({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/ventas/clientesSolicitud/' + data)
                    .then((response) => {
                        let clientes = [{ Codigo: 0, Nombre: "No aplica", NombreComercial: "No aplica" }].concat(response.data);
                        commit('setClientePr', clientes)
                        resolve(true)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchGastosPr({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/ventas/gastos/' + data)
                    .then((response) => {
                        commit('setGastosPr', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchTiposPr({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/ventas/tipos', { params: data })
                    .then((response) => {
                        commit('setTiposPr', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchTiposSolPr({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/ventas/tiposSol', { params: data })
                    .then((response) => {
                        commit('setTiposSolPr', response.data)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchSolicitudPr({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/auth/ventas/solicitudPr", data)
                    .then(response => {
                        commit("setSolicitudPr", response.data);
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                        console.error(error);
                    });

            })
        },
        fetchSolicitudPrCabecera({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post("/api/auth/ventas/solicitudPrCabecera", data)
                    .then(response => {
                        if (response.data[0].factura.length != 0) {
                            var newFactura = response.data[0].factura.map((e) => {
                                e.proveedor = { codigo: e.codigo, nombre: e.nombre };
                                return e;
                            })
                            response.data[0].factura = newFactura;
                        }
                        commit("setSolicitudPrCabecera", response.data[0]);
                        resolve(response.data[0]);
                    })
                    .catch(error => {
                        reject(error);
                        console.error(error);
                    });
            })
        },
        fetchSolicitudPrDetalle({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post("/api/auth/ventas/solicitudPrDetalle", data)
                    .then(response => {
                        commit("setSolicitudPrCabecera", response.data);

                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                        console.error(error);
                    });
            })
        },
        fetchSaldo({}, data) {
            return new Promise((resolve, reject) => {
                axios.post("/api/auth/ventas/saldo", data)
                    .then(response => {
                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                        console.error(error);
                    });
            })
        },
        fetchCanales({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/ventas/canales', { params: data })
                    .then((response) => {
                        commit('setCanalesPr', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchCanalesSol({ commit }, data) {
            commit('setCanalesSolPr', [])
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/ventas/canalesSol', { params: {co_tipo: data.tipo.co_tipo, Usuario: data.Usuario, VLPermisos: data.VLPermisos} })
                .then((response) => {
                    // let canales = (data.tipo.marketing==1)?[{Id_tipo:20, nombre:"NO APLICA"}].concat(response.data):response.data;
                    let canales;
                    let aplicaInArray = response.data.some( e => e.Id_tipo==20);
                    if (data.tipo.marketing==1 && !aplicaInArray) {
                        canales =  [{Id_tipo:20, nombre:"NO APLICA"}].concat(response.data);
                    }else{
                        canales = response.data;
                    }
                    commit('setCanalesSolPr', canales);
                    resolve(true);
                })
                .catch((error) => {
                    reject(error);
                })
            })
        },
        fetchCanalesAll({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/ventas/canalesAll')
                    .then((response) => {
                        commit('setCanalesAll', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchPresupuestos({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/ventas/presupuestos', { params: data })
                    .then((response) => {
                        commit('setPresupuestos', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchReporte({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/ventas/reporte-presupuesto', { params: data })
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchPresupuesto({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/ventas/presupuesto', { params: data })
                    .then((response) => {
                        commit('setCodigo', response.data.co_presupuesto)
                        if (response.data.alcance) {
                            commit('setPresupuestoDetalle', response.data.alcance)
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        changeCodigo({ commit }, codigo) {
            commit('setCodigo', codigo)
        },
        fetchSubCanales({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/ventas/subcanales', { params: data })
                    .then((response) => {
                        commit('setSubCanalesPr', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        addPresupuestoDetalle({ commit }, data) {
            commit('addPrDet', data)
        },
        clear({ commit }) {
            commit("clearAll")
        },
        anularPresupuesto({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/ventas/anularPresupuesto', data)
                    .then((response) => {
                        commit("clearAll")
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchPermiso({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/ventas/permisos')
                    .then((response) => {
                        commit('setPermiso', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        guardarPresupuesto({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/ventas/guardarPresupuesto', data)
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        deletePresupuesto({ commit }, index) {
            commit('delPrDet', index)
        },
        anularDetalle({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/ventas/anularDetallePresupuesto', data)
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        guardarProyeccion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/ventas/guardar-proyeccion', data)
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        guardarCuotaLibras({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/ventas/guardar-cuota-libras', data)
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        guardarCuotaDolares({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/ventas/guardar-cuota-dolares', data)
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        cargarProyeccion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/ventas/cargar-proyeccion', { params: data })
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchClientesCanal({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/ventas/clientes-canal', { params: data })
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchClientesItems({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/ventas/clientes-items', { params: data })
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchItems({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/ventas/items', { params: data })
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchCierreMes({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/ventas/cierre-mes', { params: data })
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchConceptos({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/ventas/conceptos', { params: data })
                    .then((response) => {
                        commit('setConceptos', response.data)
                        resolve(true);
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchTiposProducto({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/ventas/tiposProducto', { params: data })
                    .then((response) => {
                        commit('setTiposProducto', response.data)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        postIngresarSolicitud({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/ventas/ingresarSolicitud', data)
                    .then((response) => {
                        resolve(response.data)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        postModificarSolicitud({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/ventas/modificarSolicitud', data)
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        getDatosItem({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/ventas/datosItem', { params: data })
                    .then((response) => {
                        resolve(response.data)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        getDatosItem2({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/ventas/datosItem2', { params: data })
                    .then((response) => {
                        resolve(response.data)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchValidarPedidoCompra({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/ventas/validarPedidoCompra', { params: data })
                    .then((response) => {
                        resolve(response.data)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        postIngresarItemDetalle({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/ventas/ingresarItemDetalle', { params: data })
                    .then((response) => {
                        resolve(response.data)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        postEditarItemDetalle({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/ventas/editarItemDetalle', { params: data })
                    .then((response) => {
                        resolve(response.data)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        postEliminarItemDetalle({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/ventas/eliminarItemDetalle', { params: data })
                    .then((response) => {
                        resolve(response.data)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        getValidarValoresMuestra({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/ventas/validarValoresMuestra', { params: data })
                    .then((response) => {
                        resolve(response.data)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        getValidarValoresNc({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/ventas/validarValoresNc', { params: data })
                    .then((response) => {
                        resolve(response.data)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchInformacionSolicitante({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/ventas/informacionSolicitante', { params: data })
                    .then((response) => {
                        resolve(response.data)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        getNumeroSecuencial({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/ventas/numeroSecuencial')
                    .then((response) => {
                        resolve(response.data)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchProveedores({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/ventas/proveedores', { params: data })
                    .then((response) => {
                        resolve(response.data)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchUsuarioPresupuesto({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/ventas/usuarioPresupuesto')
                    .then((response) => {
                        resolve(response.data)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchDivisiones({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/ventas/divisiones', { params: data })
                    .then((response) => {
                        commit('setDivisiones', response.data)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchUsuarioIPSP({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/ventas/usuarioIPSP')
                    .then((response) => {
                        resolve(response.data)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchCanalesMuestra({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/ventas/canalesMuestra')
                    .then((response) => {
                        commit('setCanalesMuestra', response.data);
                        resolve(0);
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchDescargarSolicitud({ commit }, data) {
            return new Promise((resolve, reject) => {
                // axios.post('/api/auth/ventas/descargarSolicitud', data)
                axios({ method: 'post', url: '/api/auth/ventas/descargarSolicitud', responseType: 'blob', data: data })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchVendedores({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/ventas/vendedores')
                    .then((response) => {
                        commit('setVendedores', response.data);
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchClientesMuestra({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/ventas/clientesMuestra', { params: data })
                    .then((response) => {
                        commit('setClientesMuestra', response.data.data);
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchUnidades({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/ventas/unidades', { params: data })
                    .then((response) => {
                        commit('setUnidades', response.data);
                        resolve(1);
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchUnidadesConversion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/ventas/unidadesConversion', { params: data })
                    .then((response) => {
                        commit('setUnidadesConversion', response.data);
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        postIngresarPedidoMuestra({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/ventas/ingresarPedidoMuestra', data)
                    .then((response) => {
                        resolve(response.data)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        postModificarPedidoMuestra({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/ventas/modificarPedidoMuestra', data)
                    .then((response) => {
                        resolve(response.data)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        postAprobarSolicitud({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/ventas/aprobarSolicitud', data)
                    .then((response) => {
                        resolve(response.data)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        postReenviarCorreo({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/ventas/reenviarCorreo', data)
                    .then((response) => {
                        resolve(response.data)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        postRechazarSolicitud({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/ventas/rechazarSolicitud', data)
                    .then((response) => {
                        resolve(response.data)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        postEnviarSolicitudMuestra({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/ventas/enviarSolicitudMuestra', data)
                    .then((response) => {
                        resolve(response.data)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchPedidosMuestras({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/ventas/pedidosMuestras', { params: data })
                    .then((response) => {
                        commit("setPedidosMuestras", response.data)
                        resolve(response.data)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchPedidoMuestra({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/ventas/pedidoMuestra', { params: data })
                    .then((response) => {
                        resolve(response.data[0])
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchBeneficiarios({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/ventas/beneficiarios', { params: data })
                    .then((response) => {
                        commit('setBeneficiarios', response.data.data);
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        postActualizarFacturas({}, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/ventas/actualizarFacturas', data)
                    .then((response) => {
                        resolve(response.data)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        //obtengo series de ventas general
        fetchSeriesVentas({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/ventas/SeriesVentas')
                    .then((response) => {
                        commit('SET_SERIESVENTAS', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        modificarProyeccion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/ventas/modificar-proyeccion', data)
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        fetchGetProyeccionAnio({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/ventas/proyeccion-anio', { params: data})
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
         //DG
         fetchAprobarPromociones({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/ventas/AprobarPromociones', {params: data})
                    .then((response) => {
                        commit('setAprobarPromociones', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        postActualizarAprobarPromociones({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/ventas/ActualizarAprobarPromociones', data)
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
    },
}